import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { Box, Accordion as MuiAccordion } from '@mui/material';
import AccordionDetails from '@mui/material/AccordionDetails';
import AccordionSummary from '@mui/material/AccordionSummary';
import Typography from '@mui/material/Typography';
import * as React from 'react';

import CarIcon from '../../assets/icon/car-icon';

type PropsTypes = {
  title: string;
  subText: string;
};

export default function Accordion({ title, subText }: PropsTypes) {
  return (
    <MuiAccordion
      sx={{
        background: 'transparent',
        boxShadow: 'none',
        width: '100%',
      }}
    >
      <AccordionSummary
        aria-controls="panel1a-content"
        expandIcon={<ExpandMoreIcon />}
        id="panel1a-header"
      >
        <Box mr={1}>
          <CarIcon />
        </Box>
        <Typography fontWeight={'600'} gutterBottom variant="subtitle1">
          {title}
        </Typography>
      </AccordionSummary>
      <AccordionDetails>
        <Typography>{subText}</Typography>
      </AccordionDetails>
    </MuiAccordion>
  );
}
